import { render, staticRenderFns } from "./SchoolWorks.vue?vue&type=template&id=2d9a80fb"
import script from "./SchoolWorks.vue?vue&type=script&lang=js"
export * from "./SchoolWorks.vue?vue&type=script&lang=js"
import style0 from "./SchoolWorks.vue?vue&type=style&index=0&id=2d9a80fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports